export const departmentCodeList = {
  other: "Autre",
  management: "Direction",
  accounting: "Comptabilité, finance, trésorie",
  technical_service_fluid_management:
    "Service technique de gestion des fluides",
  health_safety_environment: "Service santé, sécurité, environnement",
};
